
// SYSTEM_LANGUAGE Action Types

export const GET_SYSTEM_LANGUAGE = 'GET_SYSTEM_LANGUAGE';
export const FETCH_SYSTEM_LANGUAGE = 'FETCH_SYSTEM_LANGUAGE';
export const SET_SYSTEM_LANGUAGE = 'SET_SYSTEM_LANGUAGE';
export const SET_SYSTEM_LANGUAGE_DATASTATE = 'SET_SYSTEM_LANGUAGE_DATASTATE';
export const INSERT_SYSTEM_LANGUAGE = 'INSERT_SYSTEM_LANGUAGE';
export const UPDATE_SYSTEM_LANGUAGE = 'UPDATE_SYSTEM_LANGUAGE';
export const INSERT_SYSTEM_LANGUAGE_SECTION = 'INSERT_SYSTEM_LANGUAGE_SECTION';
export const DELETE_SYSTEM_LANGUAGE = 'DELETE_SYSTEM_LANGUAGE';
